// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ca-b";
export var colorBlue = "_ca-8";
export var colorDot = "_ca-0";
export var colorDotLarge = "_ca-2";
export var colorDotSmall = "_ca-1";
export var colorGreen = "_ca-7";
export var colorGrey = "_ca-3";
export var colorOrange = "_ca-5";
export var colorPink = "_ca-a";
export var colorPurple = "_ca-9";
export var colorRed = "_ca-4";
export var colorYellow = "_ca-6";